import {Routes} from '@angular/router';
import {NavMenuComponent} from './core/nav-menu/nav-menu.component';
import {quoteRoutes} from './core/quotes/quote.routes';
import {detailsRoutes} from "./core/details/details.routes";
import {MyQuotesComponent} from "./core/my-quotes/my-quotes/my-quotes.component";
import {myQuotesRoutes} from "./core/my-quotes/my-quotes.routes";
import {dealsRoutes} from "./core/deals/deals/deals.routes";
import {contactRoutes} from "./core/contact/contact/contact.routes";
import {dashboardRoutes} from "./core/dashboard/dashboard/dashboard.routes";
import {DealsComponent} from "./core/deals/deals/deals.component";
import {myRemedialsRoutes} from "./core/my-remedials/my-remedials.routes";
import {createRemedialRoutes} from "./core/create-remedial/create-remedial.routes";
import {myOrdersRoutes} from "./core/my-orders/my-orders.routes";
import {authGuard} from "./auth/auth.guard";

export const routes: Routes = [
  {
    path: '',
    component: NavMenuComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [authGuard],
        pathMatch: 'full',
        component: DealsComponent
      },
      {
        path: 'quotes',
        canActivate: [authGuard],
        children: quoteRoutes
      },
      {
        path: 'details',
        canActivate: [authGuard],
        children: detailsRoutes
      },
      {
        path: 'myquotes',
        canActivate: [authGuard],
        children: myQuotesRoutes
      },
      {
        path: 'deals',
        canActivate: [authGuard],
        children: dealsRoutes
      },
      {
        path: 'contact',
        canActivate: [authGuard],
        children: contactRoutes
      },
      {
        path: 'dashboard',
        canActivate: [authGuard],
        children: dashboardRoutes
      },
      {
        path: 'myremedials',
        canActivate: [authGuard],
        children: myRemedialsRoutes
      },
      {
        path: 'createremedial',
        canActivate: [authGuard],
        children: createRemedialRoutes
      },
      {
        path: 'myorders',
        canActivate: [authGuard],
        children: myOrdersRoutes
      }
    ]
  }
];
